import { render, staticRenderFns } from "./ListItemSpeciality.vue?vue&type=template&id=79d3c38c&"
import script from "./ListItemSpeciality.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ListItemSpeciality.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79d3c38c')) {
      api.createRecord('79d3c38c', component.options)
    } else {
      api.reload('79d3c38c', component.options)
    }
    module.hot.accept("./ListItemSpeciality.vue?vue&type=template&id=79d3c38c&", function () {
      api.rerender('79d3c38c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ListItemSpeciality/ListItemSpeciality.vue"
export default component.exports